import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import data from '../../data/main-page/according';

function DarkSection2() {
  const [openFaqIndex, setOpenFaqIndex] = useState(null);

  return (
    <section className="tc-dark-sections-st2">
      <div className="tc-testimonials">
        <div className="container">
          <div className="rotate-box" data-speed="1" data-lag="0.4">
            <a
              href="#0"
              className="rotate-circle rotate-text d-inline-block text-uppercase"
            >
              <svg className="textcircle" viewBox="0 0 500 500">
                <defs>
                  <path
                    id="textcircle"
                    d="M250,400 a150,150 0 0,1 0,-300a150,150 0 0,1 0,300Z"
                  ></path>
                </defs>
                <text>
                  <textPath xlinkHref="#textcircle" textLength="900">
                    - trusted by clients - testimonials
                  </textPath>
                </text>
              </svg>
            </a>
            <span className="num">
              <i className="fas fa-quote-right"></i>
            </span>
          </div>
          <div
            className="testimonials-content wow fadeInUp slow"
            data-wow-delay="0.2s"
          >
            <div className="row justify-content-center">
              <div className="col-lg-8">
                <div className="testimonials-slider">
                  <div className="swiper-wrapper">
                    <div className="swiper-slide">
                      <div className="slide-card">
                        <h3 className="main-text">
                          “Dynamic Decor completely transformed our commercial project. 
                          The Delby WPC louvers and marble PVC panels offer an 
                          unmatched level of luxury and resilience.”
                        </h3>
                        <div className="btm-inf mt-70">
                          <h6 className="fsz-18 fw-bold mb-10"> Aarav Sharma </h6>
                          <p>
                            <a
                              href="#0"
                              className="text-decoration-underline color-orange1"
                            >
                              Interior Designer & Architect
                            </a>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="swiper-button-next"></div>
            <div className="swiper-button-prev"></div>
          </div>
        </div>
      </div>

      <div className="tc-faq">
        <div className="container">
          <div className="title text-center js-splittext-lines">
            <h2 className="fsz-45 mb-70 fw-500">
              {' '}
              Frequently Asked Questions{' '}
            </h2>
          </div>
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <div
                className="accordion wow zoomIn slow"
                data-wow-delay="0.2s"
                id="accordionExample"
              >
                {data.map((item, i) => {
                  const isOpen = openFaqIndex === i;
                  return (
                    <div key={i} className="accordion-item">
                      <h2 className="accordion-header">
                        <button
                          className={`accordion-button${isOpen ? '' : ' collapsed'}`}
                          type="button"
                          aria-expanded={isOpen}
                          aria-controls={`homeFaqCollapse${i}`}
                          onClick={() =>
                            setOpenFaqIndex((prev) => (prev === i ? null : i))
                          }
                        >
                          <span className="num"> {i + 1}. </span> {item.q}
                        </button>
                      </h2>
                      <div
                        id={`homeFaqCollapse${i}`}
                        className={`accordion-collapse collapse${isOpen ? ' show' : ''}`}
                      >
                        <div className="accordion-body">
                          <div className="text">{item.a}</div>
                        </div>
                      </div>
                    </div>
                  );
                })}

                <img
                  src="/home_preview/assets/img/faq_bg.png"
                  alt=""
                  className="bg"
                />
              </div>
              <p className="fsz-14 mt-20 text-center">
                Have any other questions? Please leave your comment on{' '}
                <Link to="/contact" className="text-primary text-decoration-underline">
                  our contact us page
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="tc-purchase">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <div className="content">
                <h2 className="js-splittext-lines">
                  Transform your space with premium Delby products
                </h2>
                <p
                  className="fsz-16 mt-50 wow fadeInUp slow"
                  data-wow-delay="0.2s"
                >
                  <span className="color-ccc">Every project includes</span>
                  competitive pricing, expert <br /> consultation, and guaranteed
                  <span className="color-ccc">
                    {' '}authenticity of all materials.
                  </span>
                </p>
                <Link
                  to="/contact"
                  className="butn hover-bg-black text-capitalize bg-orange1 rounded-pill text-white mt-80 wow fadeInUp slow"
                  data-wow-delay="0.3s"
                >
                  <span>
                    <i className="fas fa-phone me-1"></i> Get a Quote
                  </span>
                </Link>
                <p
                  className="fsz-16 mt-50 color-ccc wow fadeInUp slow"
                  data-wow-delay="0.4s"
                >
                  © 2024 Made by Dynamic Decor. All Rights Reserved.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="foot-img wow fadeInUp slow" data-wow-delay="0.6s">
          <div className="container">
            <div className="rotate-box" data-speed="1" data-lag="0.4">
              <a
                href="#0"
                className="rotate-circle fsz-35 rotate-text d-inline-block text-uppercase"
              >
                <svg className="textcircle" viewBox="0 0 500 500">
                  <defs>
                    <path
                      id="textcircle"
                      d="M250,400 a150,150 0 0,1 0,-300a150,150 0 0,1 0,300Z"
                    ></path>
                  </defs>
                  <text>
                    <textPath xlinkHref="#textcircle" textLength="900">
                      • premium quality • certified delby distributor
                    </textPath>
                  </text>
                </svg>
              </a>
              <span className="num"> $ </span>
            </div>
          </div>
          <img
            src="/home_preview/assets/img/foot_img.png"
            alt=""
            className="img"
          />
        </div>
      </div>
    </section>
  );
}

export default DarkSection2;
